<template>
  <b-modal
    id="modal-show-all"
    size="xl"
    :title="`Vue d'ensemble des données du parc ${parc.id}`"
  >
    <DataTables />
    <template #footer="{cancel}">
      <b-button
        variant="default"
        id="cancel-show-all"
        @click="cancel()"
      >
        Retour
        <b-tooltip target="#cancel-show-all">
          Revenir sur le panneau d'administration
        </b-tooltip>
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {BModal, BButton, BTooltip} from "bootstrap-vue-next";
import DataTables from "@/components/ParcProfileParcCardDataTables.vue";
import {useReactiveStoreGetters} from "@/composables/useStore";

// Getters
const {parc} = useReactiveStoreGetters(['parc']);

</script>
